export default {
  namespaced: true,
  inventory_equipment_type_catalog: {
    menu: "Equipment Type Catalog",
    title: "Equipment Type",
    name: "Name",
    created_at: "Created",
    updated_at: "Updated",
  },
};
